import type { DecorLook, EventDecor } from '@peles/shared';
import { apiClient } from './client';

/** The event's look and the colours its decor pictures gave. */
export async function getEventDecor(eventId: string): Promise<EventDecor> {
  const { data } = await apiClient.get<EventDecor>(`/events/${eventId}/decor`);
  return data;
}

/** Replaces the event's look; answers it as stored. */
export async function saveEventDecor(eventId: string, decor: EventDecor): Promise<EventDecor> {
  const { data } = await apiClient.put<EventDecor>(`/events/${eventId}/decor`, decor);
  return data;
}

/** What the AI reads in the event's decor pictures — a suggestion, nothing saved. */
export async function suggestEventDecor(
  eventId: string,
): Promise<{ look: DecorLook; pictures: number }> {
  const { data } = await apiClient.post<{ look: DecorLook; pictures: number }>(
    `/events/${eventId}/decor/suggest`,
  );
  return data;
}

/** Sets a plan's changes to its event's look, or takes them away (`null`). */
export async function saveFloorPlanDecor(
  floorPlanId: string,
  look: DecorLook | null,
): Promise<DecorLook | null> {
  const { data } = await apiClient.put<{ look: DecorLook | null }>(
    `/floor-plans/${floorPlanId}/decor`,
    { look },
  );
  return data.look;
}
